export const parseJsonArray = (str) => {
  if (!str) return [];
  try {
    const arr = JSON.parse(str);
    return Array.isArray(arr) ? arr : [str];
  } catch (e) {
    return str ? [str] : [];
  }
};

export const parseServiceCity = (str) => {
  if (!str) return [];
  if (Array.isArray(str)) return str;
  try {
    const arr = JSON.parse(str);
    return Array.isArray(arr) ? arr : [str];
  } catch (e) {
    return str ? [str] : [];
  }
};

export const parseLabelStr = (labelStr) => {
  if (!labelStr) return [];
  try {
    const labels = JSON.parse(labelStr);
    return Array.isArray(labels) ? labels : [];
  } catch (e) {
    return labelStr.split(',').map(s => s.trim()).filter(Boolean);
  }
};

export const parseExperiences = (expStr) => {
  if (!expStr) return [];
  try {
    const exps = JSON.parse(expStr);
    return Array.isArray(exps) ? exps : [{ date: '', desc: expStr }];
  } catch (e) {
    return expStr ? [{ date: '', desc: expStr }] : [];
  }
};

// 从工作经历时间段字符串中解析出起止的 {year, month}。
// 支持 "2021-03-2022-05"、"2025-10至2026-08"、"2022年-2023年"、"2025年02月至2026年02月" 等格式，
// 解析不到（如 "近2年-至今"）返回空数组，不抛错。
export const parseDateTokens = (dateStr) => {
  if (!dateStr) return [];
  const tokens = [];
  const re = /(\d{4})(?:[年.\-—–~至/]\s*)?(\d{1,2})?(?!\d)/g;
  let m;
  while ((m = re.exec(dateStr)) !== null) {
    tokens.push({ year: parseInt(m[1], 10), month: m[2] ? parseInt(m[2], 10) : null });
    if (tokens.length >= 2) break;
  }
  return tokens;
};

// 解析出起止 年/月 四个字段（用于编辑输入框回填），缺失的字段为空字符串。
export const parseExperienceDate = (dateStr) => {
  const tokens = parseDateTokens(dateStr);
  return {
    startYear: tokens[0] ? tokens[0].year : '',
    startMonth: tokens[0] && tokens[0].month ? tokens[0].month : '',
    endYear: tokens[1] ? tokens[1].year : '',
    endMonth: tokens[1] && tokens[1].month ? tokens[1].month : '',
  };
};

const pad2 = (n) => (n < 10 ? '0' + n : '' + n);

// 展示用格式化：解析到起止年月 → "2025年02月至2026年02月"；解析不到月份 → "2025年 至 2026年"；解析不到则返回空字符串。
export const formatExperienceDate = (dateStr) => {
  const tokens = parseDateTokens(dateStr);
  if (tokens.length === 0) return '';
  const start = tokens[0];
  const end = tokens[1] || null;
  if (end && start.month !== null && end.month !== null) {
    return `${start.year}年${pad2(start.month)}月至${end.year}年${pad2(end.month)}月`;
  }
  if (end) {
    return `${start.year}年 至 ${end.year}年`;
  }
  return start.month !== null ? `${start.year}年${pad2(start.month)}月` : `${start.year}年`;
};

// 由四个字段拼回时间段字符串（编辑输入时使用）。
export const composeExperienceDate = (fields) => {
  const part = (y, m) => {
    if (!y && !m) return '';
    let s = y ? `${y}年` : '';
    if (m) s += `${pad2(parseInt(m, 10))}月`;
    return s;
  };
  const s = part(fields.startYear, fields.startMonth);
  const e = part(fields.endYear, fields.endMonth);
  if (s && e) return `${s}至${e}`;
  return s || e || '';
};

// 返回 { start, end }（单位为 年*12+月），要求起止都包含年月；不完整返回 null。
const experienceSegment = (dateStr) => {
  const tokens = parseDateTokens(dateStr);
  if (tokens.length < 2) return null;
  const [s, e] = tokens;
  if (s.month === null || e.month === null) return null;
  return { start: s.year * 12 + s.month, end: e.year * 12 + e.month };
};

// 校验工作经历：每段起止必须包含年月、起始时间不能晚于结束时间（起止相同算一段），且任意两段不能重叠。返回错误提示，合法返回 null。
export const validateExperiences = (list) => {
  const segs = (list || []).map((exp) => experienceSegment(exp.date));
  for (let i = 0; i < segs.length; i++) {
    if (!segs[i]) return '工作经历缺少年份或月份，请补充完整';
    if (segs[i].start > segs[i].end) return '工作经历开始时间不能晚于结束时间，请更正';
  }
  for (let i = 0; i < segs.length; i++) {
    for (let j = i + 1; j < segs.length; j++) {
      const a = segs[i];
      const b = segs[j];
      if (a.start <= b.end && b.start <= a.end) {
        return '工作经历时间段有重叠，请更正';
      }
    }
  }
  return null;
};